/** Пауза после последней правки корзины, прежде чем она уйдёт на сервер одним PUT. */
export const CART_DEBOUNCE_MS = 600

/**
 * Цена применяется по Enter или уходу из поля — это решённое действие, а не набор по буквам, следующего нажатия
 * ждать нечего (RP-FB15). Ноль, а не «сразу»: соседние правки одного хода всё равно уходят одним PUT.
 */
export const CART_PRICE_DEBOUNCE_MS = 0

/**
 * Сколько ждать, прежде чем «продажа не знает команду» значит «до службы она
 * не дошла». Служба пишет операцию в продажу до POST к кассе, но перед этим
 * читает смену у кабинета; клиент ждёт ответа до 90 с.
 */
export const NOT_ARRIVED_AFTER_MS = 3 * 60_000

/** Страница подбора «☰ Каталог» (предел службы 200). */
export const PICKER_PAGE_SIZE = 200

/** UI-RMK: выдача строки поиска РМК - всё найденное, сколько отдаёт служба за запрос (предел 200); список прокручивается. */
export const SEARCH_PAGE_SIZE = 200

/** Выдача строки поиска РМК из общего каталога: страница поиска для продажи Platform (её предел - 20 строк, `SaleSearchRules.MaxLimit`). */
export const COMMON_SEARCH_PAGE_SIZE = 20

/**
 * Поиск ровно одного товара по строке или коду (Enter в строке, сканер): служба кладёт совпавший штрихкод первым, а забирается из выдачи один
 * товар, поэтому страница в 200 карточек не нужна (RP-SALE-FAST, шаг 7а): запрос короткий и на медленной сети идёт быстро. Столько же
 * позволяет заметить «штрихкод есть у нескольких товаров».
 */
export const LOOKUP_PAGE_SIZE = 10

/**
 * Точный запрос по штрихкоду (скан, Enter по целому коду): служба отдаёт карточки, у которых этот код есть целиком, — обычно одну. Вторая запись
 * нужна, чтобы заметить «штрихкод есть у нескольких товаров»; больше не бывает смысла просить.
 */
export const EXACT_BARCODE_PAGE_SIZE = 2

/** Как часто выдача строки поиска пробует снова, пока связи нет (опрос запроса в состоянии сбоя). */
export const SEARCH_RETRY_POLL_MS = 3_000

/** UI-RMK: пауза ввода в строке поиска перед запросом выдачи; Enter и сканер не ждут её. */
export const SEARCH_DEBOUNCE_MS = 250

/**
 * Как часто опрашивать ход операции сверкой (только чтение кабинета), пока окно
 * открыто и видно: первую минуту — часто (терминал отвечает за секунды), дальше
 * реже — каждая сверка пишет строку журнала службы.
 */
export const PROGRESS_POLL_MS = 1_000

/**
 * Страховочный опрос хода операции, пока окно открыто: о смене статуса кабинет сообщает вебхуком, служба перечитывает операцию и шлёт
 * окну живое событие `aqsi.operation.changed` — окно перечитывает по нему, а не опрашивает. Опрос остаётся раз в 10 с на случай, если
 * уведомление потерялось или живой канал не подключён.
 */
export const PROGRESS_SAFETY_POLL_MS = 10_000

/** Сколько окно ждёт, пока служба сама отправит чек после доказанной оплаты, прежде чем отправить его само. */
export const AUTO_RECEIPT_CLIENT_WAIT_MS = 6_000
export const PROGRESS_POLL_SLOW_MS = 15_000
export const PROGRESS_FAST_TICKS = 60

/** Сколько горит зелёная галочка «чек пробит», прежде чем РМК сам переходит к следующей продаже. */
export const SALE_DONE_FLASH_MS = 700

/**
 * Паузы между попытками повтора команды тем же ключом идемпотентности (RP-SALE-FAST): 0,5 → 1 → 2 → 4 → 8 → 10 с, дальше каждые 10 с,
 * пока сервер не подтвердит, не откажет по существу или кассир не остановит повтор. Расписание одно на корзину и оплату.
 */
export const RETRY_MAX_DELAY_MS = 10_000
export const RETRY_DELAYS_MS: readonly number[] = [500, 1_000, 2_000, 4_000, 8_000, RETRY_MAX_DELAY_MS]

/** Пауза после неудачной попытки номер `failedAttempts` (первая неудача — 1). */
export function retryDelayMs(failedAttempts: number): number {
  const index = Math.min(Math.max(failedAttempts, 1), RETRY_DELAYS_MS.length) - 1
  return RETRY_DELAYS_MS[index] ?? RETRY_MAX_DELAY_MS
}
